import { api } from "@/shared/libs/axiosClient";
import type {
  E2ETestDashboardResponse,
  RunE2ETestRequest,
  RunE2ETestResponse,
} from "@/types/collection-types";

/**
 * E2E 테스트 대시보드 데이터 조회
 */
export async function fetchE2ETestDashboard(): Promise<E2ETestDashboardResponse> {
  return api.get<E2ETestDashboardResponse>("/e2e-tests");
}

/**
 * 선택된 자산의 E2E 테스트 실행
 */
export async function runE2ETests(request: RunE2ETestRequest): Promise<RunE2ETestResponse> {
  return api.post<RunE2ETestResponse>("/e2e-tests/run", request);
}
